const styles = {
  root: {
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      '& thead tr': {
        borderBottom: '1px solid #DADADA',
      },
      '& tbody tr:nth-child(even)': {
        background: '#E9EFFD',
        '& td:first-child': {
          borderRadius: '8px 0 0 8px',
        },
        '& td:last-child': {
          borderRadius: '0 8px 8px 0',
        },
      },
      '& td': {
        padding: 16,
      },
      '& tbody td:last-child': {
        textAlign: 'right',
      },
    },

  },
};

export default styles;
